import React from 'react';

import './assets/css/divider.css';

const Divider = (): React.JSX.Element => (
  <div className='divider' role='separator' />
);

export default Divider;
